import request from '@/request'

export async function search(query) {
  query = encodeURIComponent(query)

  return await request({
    url: `/tools/answer/search?q=${query}`,
    method: 'get'
  })
}